const steps = [
	{ id: '01', title: 'Discovery', description: 'Clarify goals, users, and constraints.', icon: '🔎' },
	{ id: '02', title: 'Planning', description: 'Define roadmap, scope, and architecture.', icon: '🗺️' },
	{ id: '03', title: 'Design', description: 'Create UX flows and visual systems.', icon: '🎨' },
	{ id: '04', title: 'Development', description: 'Build iteratively with quality checks.', icon: '💻' },
	{ id: '05', title: 'Testing', description: 'Validate reliability, performance, and security.', icon: '✅' },
	{ id: '06', title: 'Launch', description: 'Deploy, monitor, and optimize continuously.', icon: '🚀' },
];

function WorkProcess() {
	return (
		<section id="process" className="rounded-3xl bg-white px-5 py-12 shadow-sm ring-1 ring-slate-200 sm:px-7 lg:px-8">
			<div className="mx-auto max-w-3xl text-center">
				<h2 className="text-3xl font-bold text-slate-900 sm:text-4xl">Our Work Process</h2>
				<p className="mt-3 text-base text-slate-600 sm:text-lg">
					A disciplined, iterative flow accelerating delivery while reducing risk.
				</p>
			</div>

			<div className="mt-8 overflow-x-auto pb-2">
				<div className="flex min-w-max items-center gap-3 pr-2">
					{steps.map((step, index) => (
						<div key={step.id} className="flex items-center gap-3">
							<div className="w-[240px] rounded-2xl border border-slate-200 bg-slate-50 p-4 text-center shadow-sm">
								<div className="mx-auto mb-2 inline-flex h-10 w-10 items-center justify-center rounded-full bg-blue-600 text-sm font-semibold text-white">
									{step.id}
								</div>
								<div className="text-2xl">{step.icon}</div>
								<h3 className="mt-2 text-lg font-semibold text-slate-900">{step.title}</h3>
								<p className="mt-1 text-sm text-slate-600">{step.description}</p>
							</div>

							{index !== steps.length - 1 && (
								<div className="flex items-center gap-1 px-1 text-blue-500">
									<span className="block h-[2px] w-6 bg-blue-400" />
									<span className="text-lg">➜</span>
								</div>
							)}
						</div>
					))}
				</div>
			</div>
		</section>
	);
}

export default WorkProcess;
